import { render, staticRenderFns } from "./ProgramStartedDialog.vue?vue&type=template&id=b9a8691c"
import script from "./ProgramStartedDialog.vue?vue&type=script&lang=js"
export * from "./ProgramStartedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports